var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1759_3559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.36102 7.46397C1.7685 6.43082 1.48241 5.58717 1.3099 4.73201C1.05476 3.46724 1.63863 2.23175 2.60586 1.44342C3.01465 1.11024 3.48327 1.22407 3.725 1.65775L4.27074 2.63682C4.70331 3.41285 4.91959 3.80087 4.87669 4.21224C4.83379 4.62362 4.54211 4.95866 3.95873 5.62875L2.36102 7.46397ZM2.36102 7.46397C3.56032 9.55517 5.4424 11.4383 7.53603 12.639M7.53603 12.639C8.56918 13.2315 9.41283 13.5176 10.268 13.6901C11.5328 13.9452 12.7682 13.3614 13.5566 12.3941C13.8898 11.9853 13.7759 11.5167 13.3423 11.275L12.3632 10.7293C11.5871 10.2967 11.1991 10.0804 10.7878 10.1233C10.3764 10.1662 10.0413 10.4579 9.37125 11.0413L7.53603 12.639Z",
    stroke: "#2177FE",
    strokeWidth: 0.9375,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1759_3559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.7bc29d07aabc0c33694d800747f2a05b.svg";
export { ForwardRef as ReactComponent };